module.exports = __webpack_public_path__ + "static/media/about.91208377.md";